import useStripe from "core/hooks/useStripe";

import { useStoreCards, useStoreDeposit } from "features/pay/store";
import { useMutateCardAdd, useMutateCardSetup, useMutateCardDefault, useMutateCardDelete, useMutateDeposit, useQueryCards } from "features/pay/data";
import { useStart } from "features/start/fabric";


let stp;
const setStp = (v) => {
	if (!stp) stp = v;
};

export const usePay = () => {
	const store = useStoreDeposit();
	const mutation = useMutateDeposit();
	const start = useStart();

	return { store, mutation, options: start.settings.token.options.amount };
};

export const useCards = () => {
	const query = useQueryCards();
	const store = useStoreCards();
	const add = useCardAdd();
	const start = useStart();

	useStripe(start.settings.stripe, setStp);

	const confirm = async (elements) => {
		const result = await stp.confirmSetup({
			elements,
			confirmParams: { return_url: `${window.location.origin}` },
			redirect: "if_required"
		});

		if (!result.error) add.mutate(result.setupIntent.payment_method);
		else store.setError({ errors: { "": [result.error.message] } });
	};

	const copy = (brand, last4) => {
		const card = `${brand} ending in ${last4}`;
		return ({
			default: {
				type: "default",
				title: "Set card as default",
				text: `${card} will be used for auto-reload and shown first when making deposits.`,
				action: {
					cancel: { text: "Cancel", color: "error" },
					save: { text: "Yes", color: "success" }
				}
			},
			delete: {
				type: "delete",
				title: "Delete card",
				text: `Are you sure you want to delete ${card}? This action cannot be undone.`,
				action: {
					cancel: { text: "Cancel", color: "success" },
					save: { text: "Delete", color: "error" }
				}
			}
		});
	};

	return { ...query, store, add, confirm, copy, stripe: stp };
};

export const useCardSetup = useMutateCardSetup;
export const useCardAdd = useMutateCardAdd;
export const useCardRemove = useMutateCardDelete;
export const useCardDefault = useMutateCardDefault;